import ExcelExport from "@/services/exportFile/exportToExcel";
import printJS from "print-js";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { nextTick } from "vue";

const downLoadExcel = async (
  selectedFileType,
  element,
  fileName,
  fileHeaderToExport,
  fileToExport
) => {
  if (selectedFileType === "pdf") {
    if (!element) {
      console.error("Element to print not found.");
      return;
    }
    try {
      await nextTick();
      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "in",
        format: "letter",
      });

      const imgWidth = 8.5; // Page width in inches
      const pageHeight = 11; // Page height in inches
      const margin = 0.5; // Half-inch margin
      const contentHeight = pageHeight - margin * 2; // Height available for content
      pdf.setFont("helvetica", "bold");
      pdf.setFontSize(16);
      // pdf.text(`${fileName}`, imgWidth / 2, margin, { align: "center" });
      // setTimeout(() => {
      //   element.style.visibility = 'hidden';
      //   // or element.style.display = 'none';
      // }, 100);

      // Clone the element to prevent affecting the DOM
      const clonedElement = element.cloneNode(true);
      clonedElement.querySelectorAll(".d-none").forEach((el) => {
        el.classList.remove("d-none");
      });

      // Apply consistent styles for neatness
      clonedElement.style.fontFamily = "Poppins";
      clonedElement.style.fontSize = "10px";
      clonedElement.style.color = "#333";
      clonedElement.style.borderCollapse = "collapse";

      // Ensure tables and rows maintain spacing and padding
      clonedElement.querySelectorAll("table").forEach((table) => {
        table.style.width = "100%";
        table.style.marginBottom = "1rem";
        table.style.border = "1px solid #ddd";
      });

      clonedElement.querySelectorAll("tr").forEach((row) => {
        row.style.borderBottom = "1px solid #ddd";
      });

      clonedElement.querySelectorAll("th, td").forEach((cell) => {
        cell.style.padding = "8px";
        cell.style.textAlign = "left";
      });

      await processAllImages(clonedElement);
      // Split rows into pages
      const rows = Array.from(clonedElement.querySelectorAll("tr"));
      let currentPage = 0;

      while (rows.length > 0) {
        const tempTable = document.createElement("table");
        tempTable.style.borderCollapse = "collapse";
        tempTable.style.width = "100%";

        let currentHeight = 0;

        // Add rows to the current page until content height is exceeded
        while (rows.length > 0 && currentHeight < contentHeight) {
          const row = rows.shift();
          const clonedRow = row.cloneNode(true);
          tempTable.appendChild(clonedRow);

          document.body.appendChild(tempTable);
          const tempHeight = tempTable.offsetHeight / 96; // Convert px to inches
          document.body.removeChild(tempTable);

          if (tempHeight > contentHeight) {
            rows.unshift(row); // Put row back if it doesn't fit
            break;
          }

          currentHeight = tempHeight;
        }

        // Render page content
        document.body.appendChild(tempTable);
        const canvas = await html2canvas(tempTable, {
          scale: 1.5,
          useCORS: true, // Changed to true
        });
        document.body.removeChild(tempTable);

        const imgData = canvas.toDataURL("image/png");
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        if (currentPage > 0) pdf.addPage();
        pdf.addImage(
          imgData,
          "PNG",
          margin,
          margin + 0.2,
          imgWidth - margin * 2,
          imgHeight
        );

        currentPage++;
      }

      pdf.save(`${fileName}.pdf`);
    } catch (error) {
      console.error("Error generating PDF:", error);
    }
  } else {
    const filterVal = fileHeaderToExport.map((i, index) => index);
    const list = fileToExport;
    const header = fileHeaderToExport;
    ExcelExport.exportFile(filterVal, list, header, fileName, selectedFileType);
  }
};

const tableHeaderToJson = (_th) => {
  let _arr = [].map
    .call(_th, function (th) {
      return th.innerHTML;
    })
    .join("|");
  let _data = _arr.split("|");
  return Array.from(_data);
};

const tableToJson = (_table) => {
  let _trLength = _table.getElementsByTagName("tr").length;
  let _jsonData = [];
  let _obj = {};

  let _htmlToJSON = function (index) {
    let _tr = _table.getElementsByTagName("tr")[index];
    let _td = _tr.getElementsByTagName("td");
    let _arr = [].map
      .call(_td, function (td) {
        return td.innerHTML;
      })
      .join("|");
    let _data = _arr.split("|");
    _obj = Object.assign({}, _data);
    _jsonData.push(_obj);
  };
  for (var i = 1; i < _trLength; i++) {
    _htmlToJSON(i);
  }
  return _jsonData;
};
async function processAllImages(element) {
  const images = element.querySelectorAll("img");

  await Promise.all(
    Array.from(images).map(async (img) => {
      // Skip if already a data URL or no src
      if (!img.src || img.src.startsWith("data:")) return;

      try {
        const dataUrl = await imageToDataURL(img.src);
        if (dataUrl) {
          img.src = dataUrl;
          await new Promise((resolve) => {
            img.onload = resolve;
            img.onerror = resolve;
          });
        }
      } catch (error) {
        console.warn("Failed to process image:", img.src, error);
      }
    })
  );
}

// Improved image to data URL converter
async function imageToDataURL(url) {
  return new Promise((resolve) => {
    const img = new Image();
    img.crossOrigin = "Anonymous";

    img.onload = () => {
      try {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        resolve(canvas.toDataURL("image/png"));
      } catch (e) {
        console.warn("Canvas error:", e);
        resolve(null);
      }
    };

    img.onerror = () => {
      console.warn("Image load failed:", url);
      resolve(null);
    };

    // Add cache busting parameter
    img.src = url + (url.includes("?") ? "&" : "?") + "t=" + Date.now();
  });
}

export default {
  tableToJson,
  tableHeaderToJson,
  downLoadExcel,
  printJS,
};
